import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';

import { ECharts, init, EChartsOption } from 'echarts';
import { fromEvent, takeUntil } from 'rxjs';

import { Destroyable } from '@src/app/utils/Destroyable';

@Component({
  selector: 'app-chart-line',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chart-line.component.html',
  styleUrls: ['./chart-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartLineComponent extends Destroyable {

  @Input('ChartConfig') public set ChartConfig(config: EChartsOption) {
    if (config) {
      this.initChart(config);
    }
  }

  private get chartElementRef(): HTMLDivElement {
    return this.elementRef.nativeElement.querySelector('#chartElement');
  }

  protected ChartInstance: ECharts;

  constructor(
    private elementRef: ElementRef,
    private changeDetRef: ChangeDetectorRef,
  ) {
    super();
  }

  public getImageDataChart(fileName: string): void {
    if (this.ChartInstance) {
      const imgURL = this.getChartImageBase64();
      const link = document.createElement('a');
      link.href = imgURL;
      link.download = `${ fileName }.png`;
      link.click();
    }
  }

  public getChartImageBase64(): string {
    const imgURL = this.ChartInstance.getDataURL({
      type: 'png',
      pixelRatio: 2,          
      backgroundColor: '#fff',
    });
    return imgURL;
  }

  private initChart(config: EChartsOption): void {
    if (this.chartElementRef) {
      this.ChartInstance = init(this.chartElementRef);
      fromEvent(window, 'resize').pipe(takeUntil(this.destroy$)).subscribe(() => this.ChartInstance.resize());
      this.ChartInstance.setOption(config);
      this.changeDetRef.markForCheck();
    }
  }

}
